export default __webpack_public_path__ + "static/media/amex.622ce6d5.svg";